export const TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const fmtDay = (iso) => new Date(iso).toLocaleDateString(undefined, { weekday: "long", day: "numeric", month: "short" });

export const fmtTime = (iso) => new Date(iso).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });

export const fmtFull = (iso) => new Date(iso).toLocaleString(undefined, {
  weekday: "short", day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit", timeZoneName: "short",
});

export const toLocalInput = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};

export const DAYS = [["mon", "Mon"], ["tue", "Tue"], ["wed", "Wed"], ["thu", "Thu"], ["fri", "Fri"], ["sat", "Sat"], ["sun", "Sun"]];

export const DAY_PRESETS = [
  { id: "weekdays", label: "Weekdays", days: ["mon", "tue", "wed", "thu", "fri"] },
  { id: "weekends", label: "Weekends", days: ["sat", "sun"] },
  { id: "any", label: "Any day", days: DAYS.map(([d]) => d) },
];

export const HALF_HOURS = Array.from({ length: 48 }, (_, i) => `${String(Math.floor(i / 2)).padStart(2, "0")}:${i % 2 ? "30" : "00"}`);

export const fmtHHMM = (s) => {
  if (!s) return "";
  const [h, m] = s.split(":").map(Number);
  return `${h % 12 || 12}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;
};

export const timeZones = () => {
  let list = [];
  try { list = Intl.supportedValuesOf("timeZone"); } catch { list = []; }
  return list.includes(TZ) ? list : [TZ, ...list];
};

export const daysLabel = (days = []) => {
  const s = new Set(days);
  if (s.size === 7) return "Any day";
  if (s.size === 5 && !s.has("sat") && !s.has("sun")) return "Weekdays";
  if (s.size === 2 && s.has("sat") && s.has("sun")) return "Weekends";
  return DAYS.filter(([d]) => s.has(d)).map(([, l]) => l).join(", ");
};

export const prefLabel = ({ days, from, to, timezone }) =>
  days?.length && from && to ? `${daysLabel(days)} · ${fmtHHMM(from)} – ${fmtHHMM(to)} (${timezone})` : "";
